import { Controller } from "@hotwired/stimulus";
import { Collapse } from "bootstrap";

// Connects to data-controller="max-members-count-to-package"

let packageSelection;
export default class extends Controller {
  static targets = ["packageInput", "maxMembersCountInput", "submitButton"];

  static values = {
    memberCounts: [9, 39, 79, 120, ">120"],
    pricesPerMemberCounts: {
      package_s: {
        default: 500,
        tools: 500,
        courses: 500,
        to_teach: 500,
        combo: 750,
        combo_to_teach: 1000,
        max_members: 9,
        key: "package_s",
      },
      package_m: {
        default: 1000,
        tools: 1000,
        courses: 1000,
        to_teach: 1500,
        combo: 1500,
        combo_to_teach: 2000,
        max_members: 39,
        key: "package_m",
      },
      package_l: {
        default: 1500,
        tools: 1500,
        courses: 1500,
        to_teach: 2500,
        combo: 2250,
        combo_to_teach: 3000,
        max_members: 79,
        key: "package_l",
      },
      package_xl: {
        default: 2000,
        tools: 2000,
        courses: 2000,
        to_teach: 3500,
        combo: 3000,
        combo_to_teach: 4000,
        max_members: 120,
        key: "package_xl",
      },
      package_custom: {
        default: 2000,
        tools: 2500,
        courses: 2500,
        to_teach: 4500,
        combo: 4000,
        combo_to_teach: 5000,
        key: "package_custom",
      },
    },
  };

  maxMembersCountInputTargetConnected() {
    // this.selectCount();
  }

  selectCount() {
    packageSelection = this.definePackageSelection();

    if (packageSelection) {
      // select member count radio button
      this.select(packageSelection);
      // show price
      this.updatePrice(packageSelection);
    }
  }

  definePackageSelection() {
    const maxMembersCount = this.maxMembersCountInputTarget.value;
    if (
      maxMembersCount === "" ||
      maxMembersCount === null ||
      maxMembersCount === undefined
    ) {
      return;
    }

    packageSelection = Object.values(this.pricesPerMemberCountsValue).find(
      (packageOption) => maxMembersCount <= packageOption.max_members
    )?.key;

    if (maxMembersCount > 120) {
      packageSelection = "package_custom";
    }

    return packageSelection;
  }

  refreshPrice(event) {
    const count = event.target.value;
    this.updatePrice(count);
  }

  select(packageSelection) {
    this.packageInputTargets.forEach((input) => {
      // eslint-disable-next-line no-param-reassign
      input.checked = input.value.toString() === packageSelection;
    });
  }

  updatePrice(packageSelection) {
    const collapseElement = document.getElementById(
      "collapse-pricing-table-non-offerable"
    );
    const bsCollapse = new Collapse(collapseElement, {
      toggle: false,
    });

    if (packageSelection === "package_custom") {
      bsCollapse.show();
      document.getElementById("pricing-table--offerable").style.display =
        "none";
      this.submitButtonTarget.disabled = true;
    } else {
      bsCollapse.hide();
      document.getElementById("pricing-table--offerable").style.display = "";
      this.submitButtonTarget.disabled = false;
    }

    let price = this.pricesPerMemberCountsValue[packageSelection].courses;
    document.getElementById("licence_price-courses").innerHTML = price;

    price = this.pricesPerMemberCountsValue[packageSelection].tools;
    document.getElementById("licence_price-tools").innerHTML = price;

    price = this.pricesPerMemberCountsValue[packageSelection].combo;
    document.getElementById("licence_price-combo").innerHTML = price;

    price = this.pricesPerMemberCountsValue[packageSelection].to_teach;
    document.getElementById("licence_price-to_teach").innerHTML = price;

    price = this.pricesPerMemberCountsValue[packageSelection].combo_to_teach;
    document.getElementById("licence_price-combo_to_teach").innerHTML = price;
  }
}
